module.exports = __webpack_public_path__ + "slack-logo.png";